import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import TataMotors from '../../../Assets/Images/work/Tatamotors-new.jpg';
import Ryan from '../../../Assets/Images/work/Ryan.webp';
import GroupSoft from '../../../Assets/Images/work/GroupSoft.webp';
import Siyarams from '../../../Assets/Images/work/siyarams.webp';
import Bitspilani from '../../../Assets/Images/work/Bitspilani.webp';

import Tribevibe from '../../../Assets/Images/work/LaffaireSelect.jpg';
import americanTourister from '../../../Assets/Images/work/AmericanTourister.webp';
import godrejlaffaire from '../../../Assets/Images/work/Laffaire.webp';
import RGI from '../../../Assets/Images/work/rgi.webp';
import lakme from '../../../Assets/Images/work/lakme.webp';
import barc from '../../../Assets/Images/work/BARC.webp';
import box from '../../../Assets/Images/work/box.jpg';
import freyaa from '../../../Assets/Images/logos/work/fashion_lifestyle/freyaa.jpg';
import pret from '../../../Assets/Images/logos/pret.webp';


import worknahar from '../../../Assets/Images/work/nahar-group.jpg';
import workryan from '../../../Assets/Images/work/ryan-group.jpg';
import workmahindrasolariz from '../../../Assets/Images/work/mahindra-solarize.jpg';
import worksiyarmas from '../../../Assets/Images/work/siyaram_new.jpg';
import workdhanvarsha from '../../../Assets/Images/work/dhanvarsha_new.jpg';
import workjpinfra from '../../../Assets/Images/work/jp-Infra.jpg';
import workmchi from '../../../Assets/Images/work/MCHI-1.jpg';
import workmchinew from '../../../Assets/Images/work/MCHI-2.jpg';
import workaldo from '../../../Assets/Images/work/aldo-tmb.jpg';
import workoo from '../../../Assets/Images/work/oo.jpg';
import workcodashop from '../../../Assets/Images/work/codashop/codaShoptm.jpg';
import workchineswok from '../../../Assets/Images/work/chineseWok/chineseWok-tm.jpg';
import worksiyaramedia from '../../../Assets/Images/work/siyaram-tmb.jpg';
import workReliance from '../../../Assets/Images/work/RGI_new.jpg';
import workZuma from '../../../Assets/Images/work/zuma_new.jpg';
import workAbfl from '../../../Assets/Images/work/aditya-birla-capital.jpg';
import workmahindrasolariznew from '../../../Assets/Images/work/mahindra-solarize-2.jpg';
import workmcredmchi from '../../../Assets/Images/work/MCHI-3.jpg';

import Podcast from '../../../Assets/Images/work/podcast-new.jpg';
import DigitalAds from '../../../Assets/Images/work/digital-ads.jpg';
import ProductShoot from '../../../Assets/Images/work/product.jpg';
import RealEstateVideos from '../../../Assets/Images/work/RealEstateVideos.jpg';
import CorporateVideos from '../../../Assets/Images/work/corporate.jpg';

import Sharmaji1 from '../../../Assets/Images/work/Sharmaji1Cover.webp'
import pretMi1 from '../../../Assets/Images/work/pretMi1Cover.webp'
import freyaa1 from '../../../Assets/Images/work/freyaa1Cover.webp'
import lkMain from '../../../Assets/Images/logos/work/fashion_lifestyle/godrej-laffaire.png';

import adityabirlaBg from '../../../Assets/Images/logos/work/BFSI/aditya-birla.png';
import rgiblueychatbot from '../../../Assets/Images/logos/work/BFSI/rgi.png';
import RaisingStoreWalkInsforPretA from '../../../Assets/Images/logos/pret.webp';

import pretFestive1 from '../../../Assets/Images/work/pret_festive1Cover.webp'

import Natch from '../../../Assets/Images/work/natch/natch-main.webp'; 
import ORM from '../../../Assets/Images/work/orm-portal/orm-portal-main-thumbnail.webp'; 
import RGIChatbot from '../../../Assets/Images/work/RGI-chatbot/rgi-chatbot-main.webp'; 



import apolloenergyanalytics from '../../../Assets/Images/work/Apollo_Energy_Analytics.jpg';
import Amazonas_4U from '../../../Assets/Images/work/Amazonas_4U.jpg';
import groupsoft from '../../../Assets/Images/work/Groupsoft.jpg';
import igcb from '../../../Assets/Images/work/IGCB.jpg';
import reaviva from '../../../Assets/Images/work/Reaviva.jpg';
import shopzuma from '../../../Assets/Images/work/Shop_Zuma-1.jpg';
import siyarmas from '../../../Assets/Images/work/Siyarams.jpg';
import TataGame from '../../../Assets/Images/work/Tata-game-thumbnail.jpeg'

// Tech
export const allData = [
  
    
    {
        id: 0,
        title: "Making Pret’s packaging the new MVP of match-day moments",
        tags: [
        ],
        image: pretMi1,
        link: '/work/case-studies/pret-x-mi',
        brand: "",
        department: "Design"
    },
    
    {
        id: 0,
        title: "RGI: Making insurance agents understand products better",
        tags: [
        ],
        image: Sharmaji1,
        link: '/work/case-studies/rgi-sharmaji-vermaji',
        brand: "",
        department: "Production"
    },
    

    // {
    //     id: 0,
    //     title: "Pret - Festive Packaging ",
    //     tags: [
    //     ],
    //     image: pretFestive1,
    //     link: '/work/case-studies/pret-festive-packaging-diwali',
    //     brand: "",
    //     department: "Design"
    // },

    // {
    //     id: 0,
    //     title: "Making ABCL the Employer of Choice in the BFSI space",
    //     tags: [
    //     ],
    //     image: adityabirlaBg,
    //     link: '/work/case-studies/aditya-birla-capital',
    //     brand: "",
    //     department: "Content"
    // },
    
    // {
    //     id: 0,
    //     title: "Building a community of lifestyle aficionados for Godrej L'Affaire",
    //     tags: [
    //     ],
    //     image: lkMain,
    //     link: '/work/case-studies/godrej-laffaire-on-ground-event',
    //     brand: "",
    //     department: "Content"
    //     // department: "Content, Production"
    // },
    
    // {
    //     id: 0,
    //     title: "Providing instant access to insurance material to 100,000+ RGI agents",
    //     tags: [
    //     ],
    //     image: rgiblueychatbot,
    //     link: '/work/case-studies/rgi-bluey-chatbot',
    //     brand: "",
    //     department: "Tech"
    // },
    
    // {
    //     id: 0,
    //     title: "Creating inspirational & educational health content for RGI's magazine ",
    //     tags: [
    //     ],
    //     image: rgiblueychatbot,
    //     link: '/work/case-studies/rgi-r-health-beat-magazine',
    //     brand: "",
    //     department: "Design"
    // },
    
    // {
    //     id: 0,
    //     title: "Raising store walk-ins for Pret-A-Manger ",
    //     tags: [
    //     ],
    //     image: RaisingStoreWalkInsforPretA,
    //     link: '/work/case-studies/pret-a-manger-149-campaign',
    //     brand: "",
    //     department: "Content"
    // },
    
   
  
    // {
    //     id: 0,
    //     title: "Event coverage and audience curation for Rangilo Re ",
    //     tags: [
    //     ],
    //     link: '/work/case-studies/rangilo-re',
    //     brand: "",
    //     department: "Production"
    // },

 
 
    {
        id: 1,
        title: "Digital Ads",
        tags: [
        ],
        image: DigitalAds,
        link: '/work/case-studies/digital-ads',
        brand: "",
        department: "Production"
    },
 
    {
        id: 1,
        title: "Corporate Videos",
        tags: [
        ],
        image: CorporateVideos,
        link: '/work/case-studies/corporate-videos',
        brand: "",
        department: "Production"
    },
 
    {
        id: 1,
        title: "Podcast",
        tags: [
        ],
        image: Podcast,
        link: '/work/case-studies/podcast',
        brand: "",
        department: "Production"
    },
  
   
    {
        id: 1,
        title: "Product Shoot",
        tags: [
        ],
        image: ProductShoot,
        link: '/work/case-studies/product-shoot',
        brand: "",
        department: "Production"
    },
    {
        id: 1,
        title: "RealEstate Videos",
        tags: [
        ],
        image: RealEstateVideos,
        link: '/work/case-studies/real-estate-videos',
        brand: "",
        department: "Production"
    },


    {
        id: 5,
        title: 'Transforming Digital Presence: Modern Website for India’s #1 Non-Govt. Technical Institute, BITS Pilani',
        tags: [
            { name: 'Digital Strategy', },
            { name: 'UI/UX', },
            { name: 'Web Development', }
        ],
        image: Bitspilani,
        link: '/work/case-studies/bits-pilani',
        brand: "Bits Pilani",
        department: 'Tech'
    }, {
        id: 6,
        title: 'Unearthing India’s Next Big Content Creator with Godrej L’Affaire Select',
        tags: [
            { name: 'Brand Strategy', },
            { name: 'Community Management', },
            { name: 'IP Creation', }
        ],
        image: godrejlaffaire,
        link: '/work/case-studies/godrej-laffaire',
        brand: "Godrej Laffaire",
        department: 'Content'
    },
   
    {
        id: 2,
        title: 'Streamlining Digital Presence: 100+ Websites & CMS for Ryan International School',
        tags: [
            { name: 'Web Design', link: '' },
            { name: 'Web Development', link: '' },
            { name: 'Content Management Systems', link: '' }
        ],
        image: Ryan,
        link: '/work/case-studies/ryangroup',
        brand: 'Ryan International Group of Institutions',
        department: 'Tech'
    },
    {
        id: 1,
        title: "Driving Visibility and Engagement for Tata Motors' Commercial Vehicle Lineup",
        tags: [
            { name: 'Digital Strategy', },
            { name: 'UI/UX', },
            { name: 'Web Development', }
        ],
        image: TataMotors,
        link: '/work/case-studies/tata-trucks',
        brand: 'TATA Trucks',
        department: 'Tech'
    },
    {
        id: 8,
        title: 'Empowering Campus Influencers: Tech-Driven Ambassador Program for TribeVibe',
        tags: [
            { name: 'Digital Strategy', },
            { name: 'UI/UX', },
            { name: 'Web Development', }
        ],
        image: Tribevibe,
        link: '/work/case-studies/tribevibe',
        brand: "Tribevibe",
        department: 'Tech'
    },
   
   
   
    {
        id: 3,
        title: 'Modernizing Digital Identity: Revamped Website for Global SaaS Company Groupsoft',
        tags: [
            { name: 'Web Design', link: '' },
            { name: 'Web Development', link: '' },
            { name: 'UI/UX Design', link: '' }
        ],
        image: GroupSoft,
        link: '/work/case-studies/groupsoft',
        brand: 'Groupsoft US Inc',
        department: 'Tech'

    },  

    {
        id: 1,
        title: "Revamping Natch Snacks’ Website to Drive Conversions and Reduce Purchase Friction",
        tags: [
            { name: 'Website Strategy', },
            { name: 'UI/UX', },
            { name: 'Web Application', }
        ],
        image: Natch,
        link: '/work/case-studies/revamping-natch-snacks-website-to-drive-conversions-and-reduce-purchase-friction',
        brand: 'Natch',
        department: 'Tech'
    },

     {
        id: 1,
        title: "Centralized ORM Portal: From Manual Tracking to Real-Time Intelligence",
        tags: [
            { name: 'Website Strategy', },
            { name: 'UI/UX', },
            { name: 'Web Application', }
        ],
        image: ORM,
        link: '/work/case-studies/ORMPortal',
        brand: 'ORMPortal',
        department: 'Tech'
    },

     {
        id: 1,
        title: "Transforming RGI Customer Communication with an Intelligent WhatsApp Chatbot",
        tags: [
            { name: 'Website Strategy', },
            { name: 'UI/UX', },
            { name: 'Web Application', }
        ],
        image: RGIChatbot,
        link: '/work/case-studies/transforming-rgi-customer-communication-with-an-intelligent-whatsapp-chatbot',
        brand: 'RGIChatBot',
        department: 'Tech'
    },
    
    
    {
        id: 4,
        title: "Elevating Men's Fashion: A Visually Captivating Website for Siyaram's",
        tags: [
            { name: 'Web Design', link: '' },
            { name: 'Web Development', link: '' },
            { name: 'UI/UX Design', link: '' }
        ],
        image: Siyarams,
        link: '/work/case-studies/siyaram',
        brand: "Siyaram's",
        department: 'Tech'
    },

     {
        id: 4,
        title: "Interactive 3D Game Experience for Tata Motors’ Ace Pro Launch",
        tags: [
            { name: 'Web Design', link: '' },
            { name: 'Web Development', link: '' },
            { name: 'UI/UX Design', link: '' }
        ],
        image: TataGame,
        link: '/work/case-studies/interactive-3d-game-experience-for-tata-motors-ace-pro-launch ',
        brand: "Tata",
        department: 'Tech'
    },
  
  


    {
        id: 7,
        title: 'Visualizing Insights: Award-Winning Yearbook for BARC India',
        tags: [
            { name: 'Annual Report', },
            { name: 'Book Design', },
            { name: 'Infographics', }
        ],
        image: barc,
        link: '/work/case-studies/barc-india-yearbook',
        brand: "BARC India Yearbook",
        department: 'Design'
    },
  
   

    {
        id: 9,
        title: 'Innovative Product Communication for Enhanced Brand Visibility',
        tags: [
            { name: 'Product Development', link: '' },
            { name: 'Multi-Channel Communication', link: '' }
        ],
        image: RGI,
        link: '/work/case-studies/product-communication-for-reliance-general-insurance',
        brand: "Product Communication for Reliance General Insurance",
        department: 'Content'
    },
    {
        id: 10,
        title: 'Capturing the Glamour: Content Creation and Event Coverage for Lakme Fashion Week',
        tags: [
            { name: 'Content Creation', link: '' },
            { name: 'Event Coverage', link: '' }
        ],
        image: lakme,
        link: '/work/case-studies/lakme-fashionweek',
        brand: "Lakme Fashion Week",
        department: 'Content'
    },
    {
        id: 11,
        title: 'Showcasing Excellence: Captivating Product Films for American Tourister',
        tags: [
            { name: 'Product Film Production', link: '' },
            { name: 'Content Creation', link: '' }
        ],
        image: americanTourister,
        link: '/work/case-studies/american-tourister',
        brand: "American Tourister",
        department: 'Production'
    },
  {
        id: 10,
        title: "Creating an ownable Women's Day narrative for Freyaa",
        tags: [
        ],
        image: freyaa1,
        link: '/work/case-studies/freyaa-woven-with-love',
        brand: "",
        department: "Production"
    },


    // New

    {
        id: 1,
        title: 'Massive Organic Growth for Nahar Group’s Search Presence',
        tags: [
            { name: 'Digital Marketing', link: '' },
            { name: 'SEO', link: '' }
        ],
        image: worknahar,
        link: '/work/case-studies/massive-organic-growth-for-nahar-groups-search-presence',
        brand: "Nahar Group’s",
        department: 'Keyword'
    },
    {
        id: 2,
        title: 'Consolidation of 91+ Websites and Tremendous SEO Growth for Ryan Group',
        tags: [
            { name: 'Digital Marketing', link: '' },
            { name: 'SEO', link: '' },
            { name: 'Website Consolidation', link: '' }
        ],
        image: workryan,
        link: '/work/case-studies/consolidation-of-91-plus-websites-and-tremendous-seo-growth-for-ryan-group',
        brand: "Ryan Group",
        department: 'Keyword'
    }, 
    {
        id: 3,
        title: 'Industry Leading Organic Search Results from Scratch for Mahindra Solarize',
        tags: [
            { name: 'Digital Marketing', link: '' },
            { name: 'SEO', link: '' },
            { name: 'Website Launch', link: '' }
        ],
        image: workmahindrasolariz,
        link: '/work/case-studies/industry-leading-organic-search-results-from-scratch-for-mahindra-solarize',
        brand: "Mahindra Solarize",
        department: 'Keyword'
    },
    // {
    //     id: 4,
    //     title: "Enhancing Organic User Engagement for Siyaram's",
    //     tags: [
    //         { name: 'Digital Marketing', link: '' },
    //         { name: 'SEO', link: '' },
    //     ],
    //     image: worksiyarmas,
    //     link: '/work/case-studies/enhancing-organic-users-engagement-for-siyarams',
    //     brand: "Siyaram's",
    //     department: 'Keyword'
    // },

    {
        id: 5,
        title: 'Successful Mobile App Download Campaign for Dhanvarsha',
        tags: [
        ],
        image: workdhanvarsha,
        link: '/work/case-studies/successful-mobile-app-download-campaign-for-dhanvarsha',
        brand: "Dhanvarsha",
        department: 'Performance Marketing'
    },
    {
        id: 6,
        title: 'Multichannel Lead Gen Campaign for JP Infra',
        tags: [
        ],
        image: workjpinfra,
        link: '/work/case-studies/multi-channel-lead-gen-campaign-for-jpinfa',
        brand: "JP Infra",
        department: 'Performance Marketing'
    },
    {
        id: 7,
        title: 'Promoting India’s Biggest Award Function for Real Estate: CREDAI MCHI Golden Pillar Awards',
        tags: [
        ],
        image: workmchi,
        link: '/work/case-studies/promoting-indias-biggest-award-function-for-real-estate-credai-mchi-golden-pillar-awards',
        brand: "CREDAI MCHI Golden Pillar Awards",
        department: 'Performance Marketing'
    },
    {
        id: 8,
        title: 'Leveraging Digital to Generate Online Registrations for an Event: MCHI Maha Property Expo',
        tags: [
        ],
        image: workmchinew,
        link: '/work/case-studies/leveraging-digital-to-generate-online-registrations-for-an-event-mchi-maha-property-expo',
        brand: "MCHI Maha Property Expo",
        department: 'Performance Marketing'
    },
    {
        id: 9,
        title: "Promoting ALDO's SS'19 and Wedding Collections",
        tags: [
        ],
        image: workaldo,
        link: '/work/case-studies/promoting-aldos-ss19-and-wedding-collections',
        brand: "ALDO's",
        department: "Performance Marketing"
    },
   
    {
        id: 10,
        title: "New Year's Campaign Hits the Mark with Siyaram's: Leveraging Celebrity Power for Maximum Impact",
        tags: [
        ],
        image: worksiyaramedia,
        link: '/work/case-studies/new-years-campaign-hits-the-mark-with-siyarams-leveraging-celebrity-power-for-maximum-impact',
        brand: "Siyaram's",
        department: "Performance Marketing"
    },
    {
        id: 10,
        title: "Chinese Wok's Post-Lockdown Revival: Influencer Campaign Boosts Starter Spread",
        tags: [
        ],
        image: workchineswok,
        link: '/work/case-studies/chinese-woks-post-lockdown-revival-influencer-campaign-boosts-starter-spread',
        brand: "Chinese Wok's",
        department: "Performance Marketing"
    },

    {
        id: 11,
        title: "Octarine Organics: Enchanting Mushroom Magic Box with Innovative Packaging Design",
        tags: [
        ],
        image: workoo,
        link: '/work/case-studies/octarine-organics-enchanting-mushroom-magic-box-with-innovative-packaging-design',
        brand: "Octarine Organics",
        department: "Design"
    },

    {
        id: 12,
        title: "Codashop Gets Gamers Grooving: Engaging BGMI Players with a Unique Rap Song and Dance Contest",
        tags: [
        ],
        image: workcodashop,
        link: '/work/case-studies/codashop-gets-gamers-grooving-engaging-bgmi-players-with-a-unique-rap-song-and-dance-contest',
        brand: "Codashop Gets Gamers Grooving",
        department: "Content"
    },

    {
        id: 13,
        title: "Driving Website Traffic and Generating High-Quality Leads for Mahindra Solarize",
        tags: [
        ],
        image: workmahindrasolariznew,
        link: '/work/case-studies/driving-website-traffic-and-generating-high-quality-leads-for-mahindra-solarize',
        brand: "Mahindra Solarize",
        department: "Performance Marketing"
    },

    {
        id: 14,
        title: "Driving Record-Breaking Lead Generation for the Biggest Property Expo of the Year by CREDAI MCHI",
        tags: [
        ],
        image: workmcredmchi,
        link: '/work/case-studies/driving-record-breaking-lead-generation-for-the-biggest-property-expo-of-the-year-by-credai-mchi',
        brand: "MCHI Maha Property Expo",
        department: "Performance Marketing"
    },

    {
        id: 15,
        title: "Boosting Agent Recruitment with a Targeted Meta Lead Generation Campaign for Reliance General Insurance",
        tags: [
        ],
        image: workReliance,
        link: '/work/case-studies/boosting-agent-recruitment-with-a-targeted-meta-lead-generation-campaign-for-reliance-general-insurance',
        brand: "Reliance General Insurance",
        department: "Performance Marketing"
    },

    {
        id: 16,
        title: "Luxury Meets Performance: Driving Sales & Awareness for Zuma Across Digital Platforms",
        tags: [
        ],
        image: workZuma,
        link: '/work/case-studies/luxury-meets-performance-driving-sales-and-awareness-for-zuma-across-digital-platforms',
        brand: "Zuma",
        department: "Performance Marketing"
    },

    {
        id: 17,
        title: "Strengthening ABFL’s Social Media Presence with a High-Impact Follower Growth Campaign",
        tags: [
        ],
        image: workAbfl,
        link: '/work/case-studies/strengthening-abfls-social-media-presence-with-a-high-impact-follower-growth-campaign',
        brand: "Aditya Birla Finance",
        department: "Performance Marketing"
    },

    
        {
            id: 17,
            title: 'Fixing Speed, Authority & Visibility: A Dual-Country SEO Success for iGCB',
            tags: [
                { name: 'Banking Software', link: '' },
                { name: 'Website & SEO', link: '' }
            ],
            image: igcb,
            link: '/work/case-studies/igcb-dual-country-seo-success',
            brand: "iGCB",
            department: 'Keyword'
        },
    
        {
            id: 16,
            title: 'From Technical Errors to Organic Wins: How Groupsoft US Reclaimed Its Digital Presence',
            tags: [
                { name: 'SAP Software Solutions', link: '' },
                { name: 'Website & SEO', link: '' }
            ],
            image: groupsoft,
            link: '/work/case-studies/groupsoft-us-organic-seo-recovery',
            brand: "Groupsoft US",
            department: 'Keyword'
        },
    
        {
            id: 15,
            title: 'Boosting Organic Growth for the Organic Brand: Amazonas 4U’s Digital Climb',
            tags: [
                { name: 'Food products supplier', link: '' },
                { name: 'Website & SEO', link: '' }
            ],
            image: Amazonas_4U,
            link: '/work/case-studies/amazonas-4u-organic-growth',
            brand: "Amazonas 4U",
            department: 'Keyword'
        },
    
        {
            id: 14,
            title: 'Accelerating Organic Success: Siyaram’s Improved Speed and Search Growth',
            tags: [
                { name: 'Fabric and Clothing Manufacturer in India', link: '' },
                { name: 'Website & SEO', link: '' }
            ],
            image: siyarmas,
            link: '/work/case-studies/siyaram-website-speed-seo-growth',
            brand: "Siyaram’s ",
            department: 'Keyword'
        },
    
        {
            id: 13,
            title: 'From Low Visibility to Industry Authority: Apollo Energy Analytics',
            tags: [
                { name: 'Services for Renewable Energy', link: '' },
                { name: 'Website & SEO', link: '' }
            ],
            image: apolloenergyanalytics,
            link: '/work/case-studies/apollo-energy-analytics-seo-authority',
            brand: "Apollo Energy",
            department: 'Keyword'
        },
    
        {
            id: 12,
            title: 'Making Siyaram’s Stores Easy to Find on Google: Managing 350+ GMB Listings',
            tags: [
                { name: 'Fabric and Clothing Manufacturer in India', link: '' },
                { name: 'Website & SEO', link: '' }
            ],
            image: siyarmas,
            link: '/work/case-studies/siyaram-gmb-local-seo-management',
            brand: "Siyaram’s",
            department: 'Keyword'
        },

        
    
        // {
        //     id: 1,
        //     title: 'Reaviva Holistic Health',
        //     tags: [
        //         { name: 'Wellness center in Mumbai', link: '' },
        //         { name: 'Website & SEO', link: '' }
        //     ],
        //     image: reaviva,
        //     link: 'work/case-studies/reaviva-holistic-health-seo-growth',
        //     brand: "Reaviva",
        //     department: 'Keyword'
        // },
    

   
];

// State for each tab

const All = () => {
    const [visibleTechItems, setVisibleTechItems] = useState(21);
    const loadMoreTechItems = () => {
        setVisibleTechItems((prev) => prev + 21);
    };

  return (
    <>
        <section className='ourWork'>
        <div className='workGrid'>
            {allData.slice(0, visibleTechItems).map((item) => (
                <div className='workGridItem' key={item.id}>
                    <div className='workGridItemLink'>
                        <Link to={item.link} className='workGridItemLink'>
                            <div className='cursor09'></div>
                            <div className='workGridItemImg'>
                                <img src={item.image} alt={item.title} loading='lazy' />
                                <div className='workGridItemHover'>
                                    <div className='workGridItemHoverIn'>
                                        <h3>{item.title}</h3>
                                        <h4>{item.brand}</h4>
                                        <p>{item.department}</p>
                                    </div>
                                </div>
                            </div>
                            <div className='workGridItemText'>
                                <h3>{item.title}</h3>
                            </div>
                        </Link>
                        <div className='workGridItemTags'>
                            {item.tags.map((tag, index) => (
                                <Link to={tag.link} className='workGridItemTag' key={index}>{tag.name}</Link>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
        {visibleTechItems < allData.length && (
            <div className='center btnSpaceEx'>
                <button onClick={loadMoreTechItems} className="loadMoreButton btnDark fontM ripple-button">See More Work</button>
            </div>
        )}
        </section>
    </>
  )
}

export default All
